var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17.195,
    viewBox: "0 0 15 17.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Home_fill",
    d: "M5.294,10.5A6.889,6.889,0,0,0,5,13.317v4.543c0,2.02,0,3.031.628,3.658.57.569,1.454.622,3.122.627V16.789a2.143,2.143,0,0,1,2.143-2.143h3.214a2.143,2.143,0,0,1,2.143,2.143v5.357c1.668,0,2.553-.058,3.122-.627C20,20.891,20,19.881,20,17.861V13.317a6.888,6.888,0,0,0-.294-2.821,6.888,6.888,0,0,0-1.951-2.059l-1.071-.918c-2-1.711-2.995-2.567-4.184-2.567s-2.187.856-4.184,2.567l-1.071.918A6.889,6.889,0,0,0,5.294,10.5Zm8.813,11.65V16.789H10.893v5.357Z",
    transform: "translate(-5 -4.951)",
    fill: "#446fa2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFill);
export default __webpack_public_path__ + "static/media/Home_fill.d5f58b560b642c01f18d3048ee4c978e.svg";
export { ForwardRef as ReactComponent };